import { ReactNode } from 'react'
import { Typography } from 'antd'

interface IProps {
  children: ReactNode
}

interface IPropsCard {
  className?: string
  children: ReactNode
  loading?: boolean
  spinnerTestId?: string
  dataTestId?: string
}

interface IPropsHeader {
  border?: boolean
  children?: ReactNode
  className?: string
}

interface IPropsBody {
  className?: string
  children?: ReactNode
}

interface IPropsHeaderTitle {
  title?: string
  titleClass?: string
  subtitle?: string
  icon?: ReactNode
  children?: ReactNode
}

export const Card = (props: IPropsCard) => {
  const { className, loading, dataTestId, spinnerTestId } = props
  return (
    <div data-testid={dataTestId} className={`spui-card ${className}`}>
      {loading && (
        <div className="spui-card__spinner" data-testid={spinnerTestId}>
          <div className="flex items-center justify-center w-full h-full text-center">
            <div className="loader" /> <span className="ml-4 font-medium">Memuat...</span>
          </div>
        </div>
      )}
      {props.children}
    </div>
  )
}

const Header = (props: IPropsHeader) => (
  <div
    className={`spui-card__header ${props.border && 'border-b-2 border-solid border-primary-600'} ${
      props.className
    }`}
  >
    {props.children}
  </div>
)

const Title = (props: IPropsHeaderTitle) => (
  <div className="spui-card__header__title">
    {props.icon && <div className="mr-4">{props.icon}</div>}
    <div className="spui-card__header__title__wrapper">
      {props.title && (
        <Typography.Title
          className={`mt-0 mb-0 text-xl text-primary ${props.titleClass}`}
          level={3}
        >
          {props.title}
        </Typography.Title>
      )}

      {props.subtitle && (
        <Typography.Text className="mb-0 font-bold">{props.subtitle}</Typography.Text>
      )}
    </div>
  </div>
)

const Body = (props: IPropsBody) => (
  <div className={`spui-card__body ${props.className}`}>{props.children}</div>
)
const Footer = (props: IProps) => <div className="spui-card__footer">{props.children}</div>

Card.Body = Body
Card.Header = Header
Card.Title = Title
Card.Footer = Footer

export default Card
